export default {"src":"/_next/static/media/male_5.96a741a8.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};